import React, { forwardRef } from "react";
import { rem } from "polished";
import styled from "styled-components";

import { IconPin } from "../../../atoms";
import { FormInput } from "../../../atoms/form/form-input";
import { device } from "../../../../../utils";

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  height: ${rem("40px")};
  padding: ${({ theme }) => `0 ${theme.spacing.size18}`};
  border-radius: ${rem("20px")};
  box-shadow: ${({ theme }) => theme.shadows.inputField};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.size12};

  @media ${device.tablet} {
    margin-right: ${({ theme }) => theme.spacing.size22};
  }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

export const FilterFieldPostcode = forwardRef(
  (
    { ...props }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
  ): JSX.Element => (
    <InputContainer>
      <IconContainer>
        <IconPin />
      </IconContainer>
      <FormInput
        {...props}
        innerRef={ref as React.RefObject<HTMLInputElement>}
      />
    </InputContainer>
  ),
);
